class TabList extends HTMLElement {
  constructor() {
    super();
    this.tabFocus = 0;
    this.changeFitGuide = this.changeFitGuide.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[role="tablist"]');
    if (!this.tabs || this.tabs.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.changeFitGuide);
    });
  }

  changeFitGuide(e) {
    const targetFitGuide = e.target;

    this.tabs.forEach((tab) => {
      tab.classList.remove('tw-border-b-2', '!tw-font-bold');
    });

    targetFitGuide.classList.add('tw-border-b-2', '!tw-font-bold');

    const tabKey = targetFitGuide.getAttribute('tab-key');
    const fitGuideList = this.querySelectorAll('[fit-key]');
    fitGuideList.forEach((fitGuide) => {
      fitGuide.classList.add('tw-hidden');
      fitGuide.classList.remove('tw-block');
    });

    const selectedFitGuide = Array.from(fitGuideList).find(
      (fitGuide) => fitGuide.getAttribute('fit-key') === tabKey
    );
    if (selectedFitGuide) {
      selectedFitGuide.classList.remove('tw-hidden');
      selectedFitGuide.classList.add('tw-block');
    }

    const fitLevelList = this.querySelectorAll('[tight-level]');

    fitLevelList.forEach((fitLevel) => {
      const mainFitId = fitLevel.querySelector('.main-fit-id');
      if (mainFitId) {
        mainFitId.classList.remove('tw-bg-black');
        mainFitId.classList.add('tw-bg-[#c1c1c1]');
      }

      const additionalFitId = fitLevel.querySelector('.additional-fit-id');
      if (additionalFitId) {
        additionalFitId.classList.remove('tw-bg-black');
        additionalFitId.classList.add('tw-bg-[#c1c1c1]');
      }

      const textFitId = fitLevel.querySelector('.text-fit-id');
      if (textFitId) {
        textFitId.classList.remove('tw-text-black');
        textFitId.classList.add('tw-text-[#a2a2a2]');
      }
    });

    const tabFitLevel = targetFitGuide.getAttribute('tab-fit-level');

    const selectedFitLevel = Array.from(fitLevelList).find(
      (fitLevel) => fitLevel.getAttribute('tight-level') === tabFitLevel
    );
    if (selectedFitLevel) {
      const mainFitId = selectedFitLevel.querySelector('.main-fit-id');
      if (mainFitId) {
        mainFitId.classList.remove('tw-bg-[#c1c1c1]');
        mainFitId.classList.add('tw-bg-black');
      }

      const additionalFitId = selectedFitLevel.querySelector('.additional-fit-id');
      if (additionalFitId) {
        additionalFitId.classList.remove('tw-bg-[#c1c1c1]');
        additionalFitId.classList.add('tw-bg-black');
      }

      const textFitId = selectedFitLevel.querySelector('.text-fit-id');
      if (textFitId) {
        textFitId.classList.remove('tw-text-[#a2a2a2]');
        textFitId.classList.add('tw-text-black');
      }
    }
  }
}

customElements.define('tab-list', TabList);
